var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col lg-12\">\n<h3>\nFornitori e corrieri del documento: {{moduloCtrl.selezione[0].riferimento_numerico}}\n</h3>\n<table class=\"table table-condensed table-striped table-responsive\">\n<tbody>\n<tr>\n<th>Fornitori</th>\n<td>{{moduloCtrl.docforncor.fornitori}}</td>\n</tr>\n<tr>\n<th>Corrieri</th>\n<td>{{moduloCtrl.docforncor.corrieri}}</td>\n</tr>\n</tbody>\n</table>\n</div>";
var id1="datiforncor.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;